(function () {

  const translations = {
    "Leave a Review": "Lascia una recensione",
    "Write a review": "Scrivi una recensione",
    "Review": "Recensione",
    "Reviews": "Recensioni",
    "reviews": "recensioni",
    "month ago": "mese fa",
    "months ago": "mesi fa",
    "week ago": "settimana fa",
    "weeks ago": "settimane fa",
    "day ago": "giorno fa",
    "days ago": "giorni fa"
  };

  function replaceTextInNode(node) {

    if (node.nodeType === Node.TEXT_NODE) {
      Object.keys(translations).forEach(key => {
        if (node.nodeValue.includes(key)) {
          node.nodeValue = node.nodeValue.replace(
            key,
            translations[key]
          );
        }
      });
    }

    node.childNodes.forEach(child => replaceTextInNode(child));
  }

  function processShadowRoots(element) {

    if (element.shadowRoot) {
      replaceTextInNode(element.shadowRoot);
    }

    element.querySelectorAll("*").forEach(el => {
      if (el.shadowRoot) {
        replaceTextInNode(el.shadowRoot);
      }
    });
  }

  const observer = new MutationObserver(() => {
    processShadowRoots(document.body);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();